import { BrickterScreen } from "../../scheme.types";

export default function BrickterCompilations() {

    const scheme: BrickterScreen = {
        path: "manager/compilation/*",
        type: "screen",
        styles: {
            width: "100%",
            maxWidth: 800,
            marginLeft: "auto",
            marginRight: "auto"
        },
        components: [
            {
                styles: {
                    animations: [
                        {
                            type: "slideUp"
                        }
                    ]
                },
                type: "screen",
                components: [
                    {
                        type: "header",
                        icon: "las la-layer-group",
                        title: "Compilations",
                        description: "Reuniones agendadas",
                        buttons: [
                            {
                                type: "button",
                                text: "Nueva",
                                icon: "la la-plus",
                                actions: [
                                    {
                                        type: "redirect",
                                        path: "insert"
                                    }
                                ]
                            }
                        ],
                        bottom: {
                            icon: "la la-lock",
                            text: "Todos los datos del paciente son almacenados con claves foráneas"
                        }
                    },
                    {
                        type: "space"
                    },
                    {
                        type: "widget",
                        components: [
                            {
                                type: "table",
                                method: "GET",
                                endpoint: "/api/compilation",
                                header: {
                                    permanent: true,
                                },
                                data: [
                                    {
                                        name: 'Vinoteca',
                                        applications: 3,
                                        status: true
                                    },
                                    {
                                        name: 'Architect',
                                        applications: 3,
                                        status: false
                                    }
                                ],
                                columns: [
                                    {
                                        icon: "las la-pen",
                                        components: [
                                            {
                                                type: "icon",
                                                icon: "las la-pen"
                                            }
                                        ]
                                    },
                                    {
                                        components: [
                                            {
                                                type: "text",
                                                text: "{item.name}"
                                            }
                                        ],
                                        title: "name",
                                        styles: {
                                            width: 120,
                                        }
                                    },
                                    {
                                        icon: "las la-turn",
                                        components: [
                                            {
                                                type: "icon",
                                                icon: "las la-check",
                                                conditions: [
                                                    {
                                                        operator: '===',
                                                        value: true,
                                                        id: 'status'
                                                    }
                                                ]
                                            },
                                            {
                                                type: "icon",
                                                icon: "las la-times",
                                                conditions: [
                                                    {
                                                        operator: '===',
                                                        value: false,
                                                        id: 'status'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        components: [
                                            {
                                                type: "text",
                                                text: "{item.applications}"
                                            }
                                        ],
                                        title: "Applications",
                                        styles: {
                                            width: 120,
                                        }

                                    },
                                    {
                                        components: [
                                            {
                                                type: "space"
                                            }
                                        ],

                                    },
                                    {
                                        components: [
                                            {
                                                type: "date",
                                                id: "created_at"
                                            }
                                        ],

                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                path: "insert",
                type: "screen",
                mode: "modal",
                outside: {
                    path: "/manager/meets"
                },
                components: [
                    {
                        title: "New Compilation",
                        description: "Complete the form",
                        icon: "las la-pen",
                        type: "bar",
                        close: {
                            path: "/manager/meets"
                        }
                    },
                    {
                        type: "box",
                        components: [
                            {
                                type: "form",
                                actions: [
                                    {
                                        type: "redirect",
                                        cache: true,
                                        path: "/manager/meets"
                                    }
                                ],
                                endpoint: "/api/compilation",
                                method: "post",
                                inputs: [
                                    {
                                        title: "Brand",
                                        type: "select",
                                        path: "/api/patient",
                                        icon: "las la-user",
                                        name: "brand_id",
                                        placeholder: "",
                                        label: "{item.name} {item.surname}",
                                        bubble: "{item.group.name}"
                                    },
                                    {
                                        title: "Code",
                                        type: "text",
                                        icon: "las la-sms",
                                        name: "name",
                                        defaultValue: "",
                                        placeholder: ""
                                    },
                                    {
                                        title: "Repository",
                                        type: "text",
                                        icon: "lab la-git-alt",
                                        name: "name",
                                        defaultValue: "",
                                        placeholder: ""
                                    },
                                    {
                                        "title": "Status",
                                        "name": "status",
                                        "icon": "la la-male",
                                        "type": "select",
                                        "placeholder": "Select one status",
                                        "label": "{item.label}",
                                        "options": [
                                            {
                                                "id": "production",
                                                "label": "Production"
                                            },
                                            {
                                                "id": "pending",
                                                "label": "Pending"
                                            },
                                            {
                                                "id": "testing",
                                                "label": "Testing"
                                            },
                                        ]
                                    },
                                    {
                                        type: "submit",
                                        value: "Save"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                path: "update/:meet_id",
                type: "screen",
                mode: "modal",
                outside: {
                    path: "/manager/meets"
                },
                components: [
                    {
                        type: "retrieve",
                        endpoint: "/api/compilation/{params.meet_id}",
                        method: "get",
                        components: [
                            {
                                title: "Editar Reunión",
                                description: "Completa el formulario",
                                icon: "las la-pen",
                                type: "bar",
                                close: {
                                    path: "/manager/meets"
                                }
                            },
                            {
                                type: "box",
                                components: [
                                    {
                                        type: "form",
                                        endpoint: "/api/compilation/{params.meet_id}",
                                        method: "put",
                                        recovery: {
                                            endpoint: "/api/compilation/{params.meet_id}",
                                            method: "get"
                                        },
                                        actions: [
                                            {
                                                type: "redirect",
                                                cache: true,
                                                path: "/manager/meets"
                                            }
                                        ],
                                        inputs: [
                                            {
                                                title: "Paciente",
                                                type: "select",
                                                path: "/api/patient",
                                                icon: "las la-user",
                                                name: "patient_id",
                                                placeholder: "",
                                                label: "{item.name} {item.surname}",
                                                bubble: "{item.group.name}"
                                            },
                                            {
                                                title: "Asunto",
                                                type: "text",
                                                icon: "las la-sms",
                                                name: "subject",
                                                placeholder: ""
                                            },
                                            {
                                                title: "Fecha de Inicio",
                                                icon: "las la-calendar",
                                                type: "datetime",
                                                name: "started_at",
                                                placeholder: ""
                                            },
                                            {
                                                title: "Fecha de Finalización",
                                                icon: "las la-calendar",
                                                type: "datetime",
                                                name: "finished_at",
                                                placeholder: ""
                                            },
                                            {
                                                title: "Observaciones",
                                                icon: "la la-address-card",
                                                name: "description",
                                                type: "textarea"
                                            },
                                            {
                                                type: "submit",
                                                value: "Guardar"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                path: "delete/:meet_id",
                type: "screen",
                mode: "modal",
                outside: {
                    path: "/manager/meets"
                },
                components: [
                    {
                        title: "Eliminar Cita",
                        description: "Acción irreversible",
                        icon: "las la-trash-alt",
                        type: "bar",
                        close: {
                            path: "/manager/meets"
                        }
                    },
                    {
                        type: "box",
                        components: [
                            {
                                type: "form",
                                actions: [
                                    {
                                        type: "redirect",
                                        cache: true,
                                        path: "/manager/meets"
                                    }
                                ],
                                endpoint: "/api/compilation/{params.meet_id}",
                                method: "delete",
                                inputs: [
                                    {
                                        type: "submit",
                                        value: "Eliminar"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }
    return scheme

}